/**
 * Dark theme: TablePagination text and icons must be light (white) for visibility.
 */
import colors from "assets/theme-dark/base/colors";

const { text } = colors;
const paginationColor = text?.main || "#f1f5f9";

const tablePagination = {
  styleOverrides: {
    root: {
      color: paginationColor,
    },
    toolbar: {
      color: paginationColor,
    },
    selectLabel: {
      color: paginationColor,
    },
    select: {
      color: paginationColor,
    },
    selectIcon: {
      color: paginationColor,
    },
    displayedRows: {
      color: paginationColor,
    },
    actions: {
      color: paginationColor,
      "& .MuiIconButton-root": {
        color: paginationColor,
      },
    },
  },
};

export default tablePagination;
